import React, { forwardRef } from 'react';
import cx from 'classnames';

export interface TextInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>, 'size'> {
  label?: string;
  error?: string;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  helpText?: string | React.ReactNode;
  helpTextClassName?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  LeftAccessory?: React.ReactNode;
  containerClassName?: string;
  inputContainerClassName?: string;
  inputClassName?: string;
  fullWidth?: boolean;
}

export const TextInput = forwardRef<any, TextInputProps>(({
  label,
  error,
  className = '',
  multiline = false,
  rows = 4,
  disabled = false,
  helpText,
  helpTextClassName = '',
  LeftAccessory,
  size = 'md',
  fullWidth = true,
  containerClassName = '',
  inputContainerClassName = '',
  inputClassName = '',
  ...props
}, ref) => {
  const inputClasses = cx(
    'block bg-white rounded-md border-gray-400 border p-2 shadow-xs',
    'focus:border-blue-500 focus:ring-blue-500 outline-hidden',
    fullWidth ? 'w-full' : '',
    LeftAccessory ? 'pl-7' : '',
    error ? 'border-red-300' : '',
    disabled ? 'bg-gray-300 text-gray-500' : '',
    size === 'xs' ? 'p-0.5 text-xs' : '',
    size === 'sm' ? 'p-1 text-sm' : '',
    size === 'md' ? 'p-2 text-md' : '',
    size === 'lg' ? 'p-3 text-lg' : '',
    className,
    inputContainerClassName,
    inputClassName
  );

  const renderInput = () => {
    if (multiline) {
      return (
        <textarea
          {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
          ref={ref}
          rows={rows}
          className={inputClasses}
          disabled={disabled}
        />
      );
    }

    return (
      <input
        ref={ref}
        {...(props as React.InputHTMLAttributes<HTMLInputElement>)}
        className={inputClasses}
        disabled={disabled}
      />
    );
  };

  return (
    <div className={containerClassName}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}

      <div className={`relative ${inputContainerClassName}`}>
        {LeftAccessory && (
          <div className="absolute left-2 top-1/2 transform -translate-y-1/2">
            {LeftAccessory}
          </div>
        )}
        {renderInput()}
      </div>

      {helpText && (
        <div className={`${helpTextClassName === undefined ? 'mt-1 text-sm text-gray-500' : ''} ${helpTextClassName}`}>
          {helpText}
        </div>
      )}

      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      
    </div>
  );
}); 